import React from 'react';
import { Link } from 'react-router-dom';

function NavItem({ item, currentPath }) {
  if (item.type === 'external') {
    return (
      <a 
        href={item.url}
        target={item.target}
        className="nav-button"
        rel="noopener noreferrer"
      >
        {item.label}
        <span className="external-icon">↗</span>
      </a>
    );
  }

  return (
    <Link 
      to={item.path}
      className={`nav-button ${currentPath === item.path ? 'active' : ''}`}
    >
      {item.label}
    </Link>
  );
}

export default NavItem;